/* Enord Core classic v1.0 — FAQ accordion behaviour (one item open at a time, like PageFly) */
(function(){
  function init(root){
    if(root.__efc)return;root.__efc=1;
    var btns=root.querySelectorAll('.efc-q');
    btns.forEach(function(b){
      b.addEventListener('click',function(){
        var open=b.getAttribute('aria-expanded')==='true';
        btns.forEach(function(o){
          o.setAttribute('aria-expanded','false');
          var p=document.getElementById(o.getAttribute('aria-controls'));
          if(p)p.classList.remove('is-open');
        });
        if(!open){
          b.setAttribute('aria-expanded','true');
          var panel=document.getElementById(b.getAttribute('aria-controls'));
          if(panel)panel.classList.add('is-open');
        }
      });
    });
  }
  function all(){document.querySelectorAll('[data-efc]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
  document.addEventListener('shopify:section:load',all);
})();
